import React, { forwardRef, useEffect } from 'react'
import clsx from 'clsx'
import { WarningIcon } from '@ow/icons'
import dittoEditor from '../ditto/register.editor'
import useEditor from './use-form-editor'

// 通用配置组件
const Config = ({ field, className, onInfoDirty }, ref) => {
  const editorFormHook = useEditor(field, ref)
  const { formRef, isDirty, getValues } = editorFormHook

  useEffect(() => {
    if (onInfoDirty) {
      onInfoDirty(isDirty)
    }
  }, [isDirty])

  const render = () => {
    const Widget = field && field.type && dittoEditor.render(field.type)
    // 数据同步问题，待类型更新之后渲染
    const targetType = getValues('type')
    return targetType === field.type ? (
      <form
        ref={formRef}
        className={clsx('relative flex flex-col items-start gap-4', className)}
      >
        {Widget ? (
          <Widget {...editorFormHook} />
        ) : (
          <div className="w-full h-full flex justify-center items-center">
            <WarningIcon width={20} height={20} />
            暂不支持该类型，敬请期待
          </div>
        )}
      </form>
    ) : null
  }
  return render()
}

export default forwardRef(Config)
